import React, { useState } from 'react';
import { PageHero } from '../components/layout/PageHero';
import { BidCard } from '../components/bids/BidCard';
import { BidFilters } from '../components/bids/BidFilters';
import { bids } from '../data/bids';
export function Bids() {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [categoryFilter, setCategoryFilter] = useState('All Categories');
  const filteredBids = bids.filter(bid => {
    const matchesSearch = bid.title.toLowerCase().includes(searchQuery.toLowerCase()) || bid.description.toLowerCase().includes(searchQuery.toLowerCase()) || bid.reference.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || bid.status === statusFilter;
    const matchesCategory = categoryFilter === 'All Categories' || bid.category === categoryFilter;
    return matchesSearch && matchesStatus && matchesCategory;
  });
  return <div data-id="element-635">
      <PageHero title="Bids & Tenders" subtitle="Explore current procurement opportunities and submit your proposals" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Bids & Tenders'
    }]} data-id="element-636" />

      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-637">
        <BidFilters searchQuery={searchQuery} setSearchQuery={setSearchQuery} statusFilter={statusFilter} setStatusFilter={setStatusFilter} categoryFilter={categoryFilter} setCategoryFilter={setCategoryFilter} data-id="element-638" />

        <div className="mb-6" data-id="element-639">
          <p className="text-gray-600" data-id="element-640">
            Showing{' '}
            <span className="font-bold text-charcoal" data-id="element-641">
              {filteredBids.length}
            </span>{' '}
            bid{filteredBids.length !== 1 ? 's' : ''}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-642">
          {filteredBids.map((bid, index) => <BidCard key={bid.id} bid={bid} index={index} data-id="element-643" />)}
        </div>

        {filteredBids.length === 0 && <div className="text-center py-12" data-id="element-644">
            <p className="text-gray-600 text-lg" data-id="element-645">
              No bids found matching your criteria.
            </p>
          </div>}
      </div>
    </div>;
}